'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _mergeImages = require('merge-images');

var _mergeImages2 = _interopRequireDefault(_mergeImages);

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

var _Button = require('../Button/Button');

var _Button2 = _interopRequireDefault(_Button);

var _Camera = require('../Camera/Camera');

var _Camera2 = _interopRequireDefault(_Camera);

var _P = require('../P/P');

var _P2 = _interopRequireDefault(_P);

var _Container = require('./components/Container');

var _Container2 = _interopRequireDefault(_Container);

var _PreviewContainer = require('./components/PreviewContainer');

var _PreviewContainer2 = _interopRequireDefault(_PreviewContainer);

var _Close = require('./components/Close');

var _Close2 = _interopRequireDefault(_Close);

var _ClosePreview = require('./components/ClosePreview');

var _ClosePreview2 = _interopRequireDefault(_ClosePreview);

var _Thumbnails = require('./components/Thumbnails');

var _Thumbnails2 = _interopRequireDefault(_Thumbnails);

var _Thumbnail = require('./components/Thumbnail');

var _Thumbnail2 = _interopRequireDefault(_Thumbnail);

var _Badge = require('./components/Badge');

var _Badge2 = _interopRequireDefault(_Badge);

var _ImageContainer = require('./components/ImageContainer');

var _ImageContainer2 = _interopRequireDefault(_ImageContainer);

var _ImageWrap = require('./components/ImageWrap');

var _ImageWrap2 = _interopRequireDefault(_ImageWrap);

var _Image = require('./components/Image');

var _Image2 = _interopRequireDefault(_Image);

var _Remove = require('./components/Remove');

var _Remove2 = _interopRequireDefault(_Remove);

var _CompleteContainer = require('./components/CompleteContainer');

var _CompleteContainer2 = _interopRequireDefault(_CompleteContainer);

var _dataUriToBlob = require('../../libs/dataUriToBlob');

var _dataUriToBlob2 = _interopRequireDefault(_dataUriToBlob);

var _blobToFile = require('../../libs/blobToFile');

var _blobToFile2 = _interopRequireDefault(_blobToFile);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _toConsumableArray(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  } else {
    return Array.from(arr);
  }
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
} // Components
// Libs


var VehicleImageTaker = function (_Component) {
  _inherits(VehicleImageTaker, _Component);

  function VehicleImageTaker() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, VehicleImageTaker);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = VehicleImageTaker.__proto__ || Object.getPrototypeOf(VehicleImageTaker)).call.apply(_ref, [this].concat(args))), _this), _this.state = _extends({}, VehicleImageTaker.INITIAL_STATE), _this.reset = function () {
      return _this.setState(_extends({}, VehicleImageTaker.INITIAL_STATE, {
        landscape: _this.isLandscape()
      }));
    }, _this.resize = function () {
      var landscape = _this.isLandscape();

      if (_this.state.landscape === landscape) return;

      _this.setState({
        landscape: landscape
      });
    }, _this.isLandscape = function () {
      return (0, _jquery2.default)(window).width() > (0, _jquery2.default)(window).height();
    }, _this.onImage = function (image) {
      _this.setState({
        images: [].concat(_toConsumableArray(_this.state.images), [image]),
        last: image.uri
      });
    }, _this.removeImage = function (position) {
      var images = [].concat(_toConsumableArray(_this.state.images)).filter(function (img) {
        return img.uri !== position.uri;
      });
      var last = _this.state.last === position.uri ? !!images.length ? images[images.length - 1] : null : _this.state.last;
      var preview = _this.state.preview && !images.length ? false : _this.state.preview;

      _this.setState({
        images: images,
        last: last,
        preview: preview
      });
    }, _this.openPreview = function () {
      if (!_this.state.images.length) return;

      _this.setState({
        preview: true
      });
    }, _this.closePreview = function () {
      if (!_this.state.preview) return;

      _this.setState({
        preview: false
      });
    }, _this.close = function () {
      var onClose = _this.props.onClose;
      var prompt = !!_this.state.images.length;
      onClose(prompt);
    }, _this.loadImage = function (_ref2) {
      var file = _ref2.file,
          uri = _ref2.uri;
      return new Promise(function (resolve) {
        var img = new Image();

        img.onload = function () {
          return resolve({
            file: file,
            uri: uri,
            img: img
          });
        };

        img.src = uri;
      });
    }, _this.complete = function () {
      var _this$props = _this.props,
          merge = _this$props.merge,
          onComplete = _this$props.onComplete;
      var images = _this.state.images;
      if (!images.length) return;
      if (!merge) return onComplete(images);
      Promise.all(images.map(_this.loadImage)).then(function (imageObjects) {
        var largestDimensions = [].concat(_toConsumableArray(imageObjects)).reduce(function (combined, _ref3) {
          var img = _ref3.img;
          if (img.width > combined.width) combined.width = img.width;
          if (img.height > combined.height) combined.height = img.height;
          return combined;
        }, {
          width: 0,
          height: 0
        });
        var rows = Math.ceil(imageObjects.length / 2);
        var columns = imageObjects.length === 1 ? 1 : 2;
        var canvasSize = {
          width: largestDimensions.width * columns,
          height: largestDimensions.height * rows
        };
        var processingImages = [].concat(_toConsumableArray(imageObjects)).map(function (_ref4, index) {
          var uri = _ref4.uri;
          var row = Math.floor(index / 2);
          var column = !((index + 1) % 2) ? 1 : 0;
          return {
            src: uri,
            x: largestDimensions.width * column,
            y: largestDimensions.height * row
          };
        });
        return (0, _mergeImages2.default)(processingImages, canvasSize);
      }).then(function (uri) {
        var blob = (0, _dataUriToBlob2.default)(uri);
        var file = (0, _blobToFile2.default)(blob, 'cameraImage.png', 'image/png');
        onComplete({
          uri: uri,
          file: file
        });
      });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(VehicleImageTaker, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.reset();
      (0, _jquery2.default)(window).on('resize', this.resize);
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      if (!prevProps.visible && this.props.visible) this.reset();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      (0, _jquery2.default)(window).off('resize', this.resize);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          visible = _props.visible,
          onError = _props.onError,
          uploadMode = _props.uploadMode,
          onUploadMode = _props.onUploadMode;
      var _state = this.state,
          preview = _state.preview,
          last = _state.last,
          images = _state.images,
          landscape = _state.landscape;
      return _react2.default.createElement(_Container2.default, {
        visible: visible
      }, _react2.default.createElement(_Camera2.default, {
        on: visible,
        uploadMode: uploadMode,
        onUploadMode: onUploadMode,
        onImage: this.onImage,
        onError: onError,
        landscape: landscape,
        fixed: true
      }), _react2.default.createElement(_Close2.default, {
        landscape: landscape
      }, _react2.default.createElement(_Button2.default, {
        icon: 'close',
        theme: 'white',
        size: 'large',
        onClick: this.close,
        outline: true,
        shadow: true
      })), !!images.length && _react2.default.createElement(_Close2.default, {
        landscape: landscape,
        right: true
      }, _react2.default.createElement(_Button2.default, {
        icon: 'check',
        theme: 'white',
        size: 'large',
        onClick: this.complete,
        outline: true,
        shadow: true
      })), _react2.default.createElement(_PreviewContainer2.default, {
        visible: preview,
        landscape: landscape
      }, _react2.default.createElement(_ImageContainer2.default, null, !!images.length ? images.map(function (image) {
        return _react2.default.createElement(_ImageWrap2.default, {
          key: image.uri
        }, _react2.default.createElement(_Image2.default, {
          src: image.uri
        }), _react2.default.createElement(_Remove2.default, null, _react2.default.createElement(_Button2.default, {
          icon: 'close',
          onClick: function onClick() {
            return _this2.removeImage(image);
          },
          size: 'large'
        })));
      }) : _react2.default.createElement(_P2.default, {
        theme: 'white'
      }, 'No images taken')), _react2.default.createElement(_CompleteContainer2.default, {
        landscape: landscape
      }, _react2.default.createElement(_Button2.default, {
        size: 'giant',
        onClick: this.complete,
        theme: 'green',
        icon: 'check'
      }))), preview ? _react2.default.createElement(_ClosePreview2.default, {
        landscape: landscape
      }, _react2.default.createElement(_Button2.default, {
        icon: 'close',
        theme: 'white',
        size: 'large',
        onClick: this.closePreview,
        outline: true,
        shadow: true
      })) : _react2.default.createElement(_Thumbnails2.default, {
        onClick: this.openPreview,
        landscape: landscape
      }, !!last && _react2.default.createElement(_Thumbnail2.default, {
        src: last
      }), !!images.length && _react2.default.createElement(_Badge2.default, null, images.length)));
    }
  }]);

  return VehicleImageTaker;
}(_react.Component);

VehicleImageTaker.propTypes = {
  visible: _propTypes2.default.bool.isRequired,
  merge: _propTypes2.default.bool,
  uploadMode: _propTypes2.default.bool,
  onUploadMode: _propTypes2.default.func.isRequired,
  onComplete: _propTypes2.default.func.isRequired,
  onClose: _propTypes2.default.func.isRequired,
  onError: _propTypes2.default.func.isRequired
};
VehicleImageTaker.defaultProps = {
  uploadMode: false,
  merge: false
};
VehicleImageTaker.INITIAL_STATE = {
  images: [],
  last: null,
  preview: false,
  landscape: false
};
exports.default = VehicleImageTaker;